module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/RpPgn2/tc-custom/9781611528428.jpg?1718251157455",
      "alt": "This image is the cover for the book It's Not Yule, It's Me"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("It's Not Yule, It's Me\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Shannon hates Christmas. Mostly because Christmas hates him. It sure seems like it, anyway: every crummy thing that’s happened to him since high school has befallen him at the Most Wonderful Time of the Year. Every humiliating break-up, every high-rise hotel fire -- heck, a few years back, one guy he had the hots for up and died."), _c('br'), _c('br'), _vm._v("Which goes a long way toward explaining why he’s a whimpering mess when he meets Ben the barista one Christmas morning at his neighborhood coffee house. It doesn’t completely excuse his using Ben’s T-shirt as a handkerchief -- while Ben’s still in it -- but Ben’s nothing if not a good sport."), _c('br'), _c('br'), _vm._v("Ben’s such a bright spot that after a while Shannon wonders if maybe his Christmas Curse hasn’t been lifted. And what better place to test this theory than at Ben’s family festivities? It’s not like Christmas is "), _c('i', [_vm._v("actually")]), _vm._v(" cursed. Is it?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael P. Thomas\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0